import { api } from './api';

export interface Notification {
  id: string;
  userId: string;
  title: string;
  message: string;
  type: string;
  read: boolean;
  createdAt: string;
  actionUrl?: string;
}

class NotificationService {
  // Função de teste para verificar conectividade
  async testConnection(): Promise<boolean> {
    try {
      const response = await api.get('/notifications');
      return true;
    } catch (error: any) {
      console.error('Teste de conexão falhou:', error);
      return false;
    }
  }

  async getNotifications(limit?: number): Promise<Notification[]> {
    try {
      const response = await api.get('/notifications');
      let notifications = response.data;
      
      // Ordenar por data de criação (mais recente primeiro)
      notifications = notifications.sort(
        (a: Notification, b: Notification) => 
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
      
      return limit ? notifications.slice(0, limit) : notifications;
    } catch (error) {
      console.error('Erro ao buscar notificações:', error);
      throw error;
    }
  }

  async getUnreadCount(): Promise<number> {
    try {
      const response = await api.get('/notifications');
      const notifications = response.data;
      return notifications.filter((n: Notification) => !n.read).length;
    } catch (error) {
      console.error('Erro ao buscar contagem de não lidas:', error);
      return 0;
    }
  }

  async markAsRead(notificationId: string): Promise<void> {
    try {
      const url = `/notifications/${notificationId}`;
      
      const response = await api.put(url);
    } catch (error: any) {
      console.error('NotificationService: Erro ao marcar notificação como lida:', error);
      console.error('NotificationService: NotificationId:', notificationId);
      console.error('NotificationService: Error details:', {
        message: error instanceof Error ? error.message : 'Unknown error',
        status: error?.response?.status,
        statusText: error?.response?.statusText,
        data: error?.response?.data,
        url: error?.config?.url,
        method: error?.config?.method
      });
      throw error;
    }
  }

  async markAllAsRead(): Promise<void> {
    try {
      await api.put('/notifications/batch');
    } catch (error) {
      console.error('Erro ao marcar todas como lidas:', error);
      throw error;
    }
  }

  async deleteNotification(notificationId: string): Promise<void> {
    try {
      await api.delete(`/notifications/${notificationId}`);
    } catch (error) {
      console.error('Erro ao excluir notificação:', error);
      throw error;
    }
  }

  async deleteAllNotifications(): Promise<void> {
    try {
      await api.delete('/notifications');
    } catch (error) {
      console.error('Erro ao excluir todas as notificações:', error);
      throw error;
    }
  }
}

export const notificationService = new NotificationService(); 